export const htmlToPlainText = (html = "") => {
  if (!html) return "";

  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/&amp;nbsp;|&nbsp;|&#160;/gi, " ")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
};

export const getExcerpt = (html, length = 300) =>
  htmlToPlainText(html).slice(0, length);
